export default __webpack_public_path__ + "static/media/component_touch_sensor.ab78ac9e.png";